import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 15,
	viewBox: "0 0 10 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.65723 14.2158C0.713867 14.2158 0.249023 13.7441 0.249023 12.7256V7.55078C0.249023 6.67578 0.672852 6.2041 1.41113 6.10156V4.41992C1.41113 1.80176 3.16797 0.543945 5 0.543945C6.83203 0.543945 8.5957 1.80176 8.5957 4.41992V6.08105C9.36816 6.15625 9.75098 6.63477 9.75098 7.55078V12.7256C9.75098 13.7441 9.29297 14.2158 8.34961 14.2158H1.65723ZM2.85352 4.29688V6.07422L7.14648 6.06738V4.29688C7.14648 2.7793 6.18262 1.93164 5 1.93164C3.81738 1.93164 2.85352 2.7793 2.85352 4.29688Z",
		fill: "#AC8E68"
	})
});
export default SvgLocked;
